import axios from 'axios';

const API_BASE_URL = 'https://app.bihebari.com.np/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
});

// Add token to requests if needed
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        console.log(`Making ${config.method.toUpperCase()} request to: ${config.url}`);
        return config;
    },
    (error) => {
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => {
        console.log(`Response from ${response.config.url}:`, response.status);
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        console.error('Response error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

// API Methods
export const registerAPI = {
    // Save personal details
    savePersonalDetails: (formData) => {
        return api.post('/personal-details', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },



// Add these methods to your registerAPI object
saveEducationDetails: (data) => {
    return api.post('/education', data);
},

getEducationDetails: (userId) => {
    return api.get(`/education/${userId}`);
},

updateEducationDetails: (userId, data) => {
    return api.put(`/education/${userId}`, data);
},

getEducationDropdowns: () => {
    return api.get('/education/dropdowns');
},


// Add these methods to your registerAPI object
saveFamilyDetails: (data) => {
    return api.post('/family', data);
},

getFamilyDetails: (userId) => {
    return api.get(`/family/${userId}`);
},

updateFamilyDetails: (userId, data) => {
    return api.put(`/family/${userId}`, data);
},

// Add these methods to your registerAPI object
saveLifePartner: (data) => {
    return api.post('/life-partner', data);
},

getLifePartner: (userId) => {
    return api.get(`/life-partner/${userId}`);
},

updateLifePartner: (userId, data) => {
    return api.put(`/life-partner/${userId}`, data);
},
    
    // Save appearance details
    saveAppearanceDetails: (data) => {
        return api.post('/appearance-details', data);
    },
    
    // Save contact details
    saveContactDetails: (data) => {
        return api.post('/contact', data);
    },
    
    // Get user by ID
    getUserById: (userId) => {
        return api.get(`/users/${userId}`);
    },
    
    // Get complete user details with all sections
    getCompleteUserDetails: (userId) => {
        return api.get(`/users/${userId}/complete`);
    },
    
    // Update personal details
    updatePersonalDetails: (userId, data) => {
        return api.put(`/personal-details/${userId}`, data);
    },
    
    // Update appearance details
    updateAppearanceDetails: (userId, data) => {
        return api.put(`/appearance-details/${userId}`, data);
    },
    
    // Update contact details
    updateContactDetails: (userId, data) => {
        return api.put(`/contact/${userId}`, data);
    },
    
    // Get contact details by user ID
    getContactDetails: (userId) => {
        return api.get(`/contact/${userId}`);
    },
    
    // Get all users with pagination
    getAllUsers: (page = 1, limit = 10) => {
        return api.get(`/users?page=${page}&limit=${limit}`);
    },
    
    // Search users
    searchUsers: (searchTerm) => {
        return api.get(`/users/search?q=${searchTerm}`);
    },
    
    // Delete user
    deleteUser: (userId) => {
        return api.delete(`/personal-details/${userId}`);
    },
    
    // Update payment status
    updatePaymentStatus: (userId, data) => {
        return api.patch(`/personal-details/${userId}/payment`, data);
    },
    
    // Health check
    healthCheck: () => {
        return api.get('/health');
    },
    
    // Dropdown APIs
    getDropdowns: () => {
        return api.get('/dropdowns');
    },
    
    // Location APIs
    getCountries: () => {
        return api.get('/locations/countries');
    },
    
    getStates: (countryId) => {
        return api.get(`/locations/states/${countryId}`);
    },
    
    getCities: (stateId) => {
        return api.get(`/locations/cities/${stateId}`);
    }
};

export default api;